<template>
	<div id="profile" class="page" v-if="!this.$parent.loading">
		<div class="columns">
			<div class="column is-two-thirds">
				<div class="panel">
					<h5 class="panel-heading">Account Profile</h5>
					<form class="panel-block">
						<b-loading :is-full-page="false" :active.sync="loading.profile" :can-cancel="false"></b-loading>
						<section>
							<div class="columns">
								<div class="column">
									<b-field label="First Name"
									         :type="fields.first_name.type"
									         :message="fields.first_name.message">
										<b-input v-model="firstName"></b-input>
									</b-field>
								</div>
								<div class="column">
									<b-field label="Last Name"
									         :type="fields.last_name.type"
									         :message="fields.last_name.message">
										<b-input v-model="lastName"></b-input>
									</b-field>
								</div>
							</div>
							<b-field label="Email Address"
							         :type="fields.email.type"
							         :message="fields.email.message">
								<b-input v-model="emailAddress"
								         type="email"
								         icon="envelope">
								</b-input>
							</b-field>

							<div class="field">
								<b-checkbox name="enable_2fa"
								            v-model="fields.enable_2fa"
								            :message="fields.enable_2fa.message">
									Enable Email 2FA
								</b-checkbox>
							</div>
							<b-button type="is-primary"
							          v-on:click="updateProfile">Save Changes
							</b-button>
						</section>
					</form>
				</div>
				<div class="panel">
					<h5 class="panel-heading">Password</h5>
					<form class="panel-block">
						<b-loading :is-full-page="false" :active.sync="loading.password" :can-cancel="false"></b-loading>
						<section>
							<p>To reset your password, enter your existing password and then the new password below.</p>
							<b-field label="Current Password"
							         :type="fields.current_password.type"
							         :message="fields.current_password.message">
								<b-input v-model="current_password"
								         type="password"
								         value=""
								         @input="clearError('current_password')"
								         password-reveal>
								</b-input>
							</b-field>
							<b-field label="New Password"
							         :type="fields.password.type"
							         :message="fields.password.message">
								<b-input v-model="password"
								         type="password"
								         value=""
								         @input="clearError('password')"
								         password-reveal>
								</b-input>
							</b-field>
							<b-field label="Confirm New Password"
							         :type="fields.password_confirmation.type"
							         :message="fields.password_confirmation.message">
								<b-input v-model="password_confirmation"
								         type="password"
								         value=""
								         @input="clearError('password_confirmation')"
								         password-reveal>
								</b-input>
							</b-field>
							<b-button type="is-primary"
							          v-on:click="updatePassword"
							          :disabled="canChangePassword">Change Password
							</b-button>
						</section>
					</form>
				</div>
			</div>
			<div class="column is-two-fifths" style="display: none;"><!-- feature not implemented -->
				<div class="panel">
					<h5 class="panel-heading">Two-Factor Authentication</h5>
					<form class="panel-block">
						<section>
							<div class="field">
								<p>Two-Factor Authentication uses your mobile device as a means to confirm your identity when logging in. You must first confirm your phone number to enable this feature.</p>

								<b-switch v-model="twoFactor"
								          :value="true"
								          type="is-success">
									Enabled
								</b-switch>

								<template v-if="twoFactor">
									<b-field label="Phone Number">
										<div class="control has-icons-left is-clearfix">
											<masked-input
												v-model="phoneNumber"
												type="text"
												name="phone"
												class="input"
												:mask="['+', '1', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
												:guide="false"
												:show-mask="true"
												placeholder="+1 (###) ###-####"
												placeholderChar="#">
											</masked-input>
											<span class="icon is-left">
                                        <b-icon icon="phone"></b-icon>
                                      </span>
										</div>
									</b-field>

									<b-button type="is-primary"
									          v-on:click="update2FA"
									          :disabled="phoneNumber === ''">Validate
									</b-button>
								</template>
							</div>
						</section>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { USER_PROFILE, USER_UPDATE } from '../store/actions/users'
import MaskedInput from 'vue-text-mask'

export default {
  name: 'Profile',
  data () {
    return {
      loading: {
        'profile': true,
        'password': false
      },
      user: {},
      firstName: '',
      lastName: '',
      emailAddress: '',
      fields: {
        'first_name': {},
        'last_name': {},
        'email': {},
        'enable_2fa': false,
        'current_password': {},
        'password': {},
        'password_confirmation': {}
      },
      twoFactor: false,
      phoneNumber: '',
      current_password: '',
      password: '',
      password_confirmation: ''
    }
  },
  components: {
    MaskedInput
  },
  computed: {
    canChangePassword: function () {
      return !(this.current_password !== '' && this.password !== '' && this.password_confirmation !== '' && this.password === this.password_confirmation)
    }
  },
  watch: {
    user: function (newUser) {
      this.firstName = newUser.name.first_name
      this.lastName = newUser.name.last_name
      this.emailAddress = newUser.email.text
      this.fields.enable_2fa = newUser.enable_2fa
    }
  },
  methods: {
    handleError (err) {
      if (err.hasOwnProperty('response')) {
        if (err.response.data.message === 'error') {
          this.$awn.warning(err.response.data.message)
        } else if (err.response.data.message) {
          this.$awn.alert(err.response.data.message)
        }
        if (err.response.data.response === 'validationError') {
          for (let field in err.response.data.data) {
            if (!err.response.data.data.hasOwnProperty(field)) continue
            this.$set(this.fields, field, {
              'type': 'is-danger',
              'message': err.response.data.data[field][0]
            })
          }
        }
      } else {
        this.$awn.alert(err.toString())
      }
    },
    getProfile () {
      this.loading.profile = true
      this.$store.dispatch(USER_PROFILE).then(response => {
        this.user = response.data
        this.loading.profile = false
      }).catch(err => {
        this.loading.profile = false
        this.handleError(err)
      })
    },
    updateProfile () {
      this.loading.profile = true
      let data = {
        'first_name': this.firstName,
        'last_name': this.lastName,
        'email': this.emailAddress,
        'enable_2fa': this.fields.enable_2fa
      }
      this.$store.dispatch(USER_UPDATE, {
        'endpoint': 'profile',
        'data': data
      }).then(response => {
        this.loading.profile = false
        this.$awn.success(response.message)
      }).catch(err => {
        this.loading.profile = false
        this.handleError(err)
      })
    },
    updatePassword () {
      this.loading.password = true
      let data = {
        'current_password': this.current_password,
        'password': this.password,
        'password_confirmation': this.password_confirmation
      }
      this.$store.dispatch(USER_UPDATE, {
        'endpoint': 'password',
        'data': data
      }).then(response => {
        this.loading.password = false
        this.$awn.success(response.message)
      }).catch(err => {
        this.loading.password = false
        this.handleError(err)
      })
    },
    clearError (field) {
      this.$set(this.fields, field, {
        'type': '',
        'message': ''
      })
    }
  },
  created () {
    this.$store.commit('setPageTitle', 'My Profile')
    this.getProfile()
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Profile.vue